module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"title-dialog-filter":"Filter hinzufügen","subtitle":"Nur in bestimmten Rollen suchen"},"fr":{"subtitle":"Rechercher uniquement dans des rôles spécifiques","title-dialog-filter":"Ajouter des filtres"},"it":{"subtitle":"Cercare solo in ruoli specifici","title-dialog-filter":"Aggiungere filtri"}}')
  delete Component.options._Ctor
}
